(function () {
  'use strict';

  var rootPrefix = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---- Smooth Anchor Scrolling ---- */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href*="#"]');
    if (!link) return;
    var href = link.getAttribute('href');
    var hash = href.indexOf('#') !== -1 ? href.substring(href.indexOf('#') + 1) : '';
    if (!hash) return;
    var target = document.getElementById(hash);
    if (!target) return;
    e.preventDefault();
    var headerH = document.querySelector('.rc-header') ? document.querySelector('.rc-header').offsetHeight : 0;
    var y = target.getBoundingClientRect().top + window.pageYOffset - headerH - 16;
    window.scrollTo({ top: y, behavior: 'smooth' });
    // Close mobile nav if open
    var mobileNav = document.querySelector('.rc-mobile-nav');
    if (mobileNav) mobileNav.classList.remove('is-open');
  });

  /* ---- Sticky Header Shadow ---- */
  var header = document.querySelector('.rc-header');
  if (header) {
    var lastScroll = 0;
    window.addEventListener('scroll', function () {
      var st = window.pageYOffset || document.documentElement.scrollTop;
      header.classList.toggle('is-scrolled', st > 10);
      lastScroll = st;
    }, { passive: true });
  }

  /* ---- Mobile Hamburger ---- */
  var hamburger = document.getElementById('rc-hamburger');
  var mobileNav = document.querySelector('.rc-mobile-nav');
  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', function () {
      mobileNav.classList.toggle('is-open');
    });
  }

  /* ---- Image Gallery ---- */
  document.querySelectorAll('.rc-gallery').forEach(function (gallery) {
    var mainImg = gallery.querySelector('.rc-gallery__main-img');
    var thumbs = gallery.querySelectorAll('.rc-gallery__thumb');
    var images = [];
    var currentIndex = 0;

    thumbs.forEach(function (thumb, i) {
      var img = thumb.querySelector('img');
      if (img) images.push(img.getAttribute('data-full') || img.src);
      thumb.addEventListener('click', function () { setActive(i); });
    });

    function setActive(i) {
      if (!mainImg || i < 0 || i >= images.length) return;
      currentIndex = i;
      mainImg.src = images[i];
      thumbs.forEach(function (t, j) { t.classList.toggle('is-active', j === i); });
    }

    var prev = gallery.querySelector('.rc-gallery__arrow--prev');
    var next = gallery.querySelector('.rc-gallery__arrow--next');
    if (prev) prev.addEventListener('click', function () { setActive((currentIndex - 1 + images.length) % images.length); });
    if (next) next.addEventListener('click', function () { setActive((currentIndex + 1) % images.length); });
  });

  /* ---- Format Price (currency + decimal separator from window.rcCurrency) ---- */
  function formatPrice(total) {
    var cur = window.rcCurrency || { symbol: '\u20AC', decimal: ',' };
    var sep = cur.decimal || ',';
    return cur.symbol + String(total).replace('.', sep);
  }

  /* ---- Bundle Selector (syncs all instances on page) ---- */
  var allQtyCards = document.querySelectorAll('.rc-qty-card');
  var allCtaPriceEls = document.querySelectorAll('.rc-cta-price');
  var allStickyPriceEls = document.querySelectorAll('.rc-sticky-price');
  var allStickyLabelEls = document.querySelectorAll('.rc-sticky-label');

  /* Find initial selection */
  var initialCard = document.querySelector('.rc-qty-card.is-selected');
  var currentVariantId = '';
  var currentTotal = '';
  var currentLabel = '';

  if (initialCard) {
    currentVariantId = initialCard.getAttribute('data-variant-id') || '';
    currentTotal = initialCard.getAttribute('data-total') || '';
    currentLabel = initialCard.getAttribute('data-label') || '';
    if (currentTotal) {
      allCtaPriceEls.forEach(function (el) { el.textContent = formatPrice(currentTotal); });
      allStickyPriceEls.forEach(function (el) { el.textContent = formatPrice(currentTotal); });
      allStickyLabelEls.forEach(function (el) { el.textContent = currentLabel; });
    }
  }

  allQtyCards.forEach(function (card) {
    card.addEventListener('click', function () {
      var group = card.getAttribute('data-group') || 'default';
      /* Deselect all cards in ALL groups (keep them synced) */
      allQtyCards.forEach(function (c) { c.classList.remove('is-selected'); });
      /* Select all cards with same data-qty value */
      var qty = card.getAttribute('data-qty');
      allQtyCards.forEach(function (c) {
        if (c.getAttribute('data-qty') === qty) c.classList.add('is-selected');
      });
      currentTotal = card.getAttribute('data-total') || '';
      currentVariantId = card.getAttribute('data-variant-id') || currentVariantId;
      currentLabel = card.getAttribute('data-label') || '';
      if (currentTotal) {
        allCtaPriceEls.forEach(function (el) { el.textContent = formatPrice(currentTotal); });
        allStickyPriceEls.forEach(function (el) { el.textContent = formatPrice(currentTotal); });
      }
      if (currentLabel) {
        allStickyLabelEls.forEach(function (el) { el.textContent = currentLabel; });
      }
    });
  });

  /* ---- Add to Cart & Open Drawer ---- */
  var isSubmitting = false;

  function addToCartAndOpenDrawer() {
    if (!currentVariantId) {
      console.warn('RC: No variant selected.');
      return;
    }
    if (isSubmitting) return;
    isSubmitting = true;

    var btns = document.querySelectorAll('.rc-atc-btn');
    btns.forEach(function (b) { b.disabled = true; b.classList.add('rc-cta-btn--loading'); });

    /* Collect bundled section IDs via Impact's event (cart drawer registers itself) */
    var sectionsToBundle = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', {
      bubbles: true,
      detail: { sections: sectionsToBundle }
    }));

    var variantIdInt = parseInt(currentVariantId, 10);

    /* Clear cart, add selected variant, open cart drawer */
    fetch(rootPrefix + 'cart/clear.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' }
    })
    .then(function () {
      /* If we'll add SP after, don't request sections yet (they'd be stale).
         If no SP, this is the last modification so request sections here. */
      var body = { items: [{ id: variantIdInt, quantity: 1 }] };
      if (!window.rcSpVariantId && sectionsToBundle.length > 0) {
        body.sections = sectionsToBundle.join(',');
        body.sections_url = rootPrefix + 'variants/' + variantIdInt;
      }
      return fetch(rootPrefix + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify(body)
      });
    })
    .then(function (res) {
      if (!res.ok) throw new Error('Add to cart failed (' + res.status + ')');
      return res.json();
    })
    .then(function (firstAddData) {
      if (!window.rcSpVariantId) {
        /* No SP — use sections from firstAddData */
        return fetch(rootPrefix + 'cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (firstAddData.sections) cart.sections = firstAddData.sections;
            return cart;
          });
      }

      /* Add SP WITH sections (last modification = sections reflect final cart state) */
      window._rcSpAdded = true;
      var spBody = { items: [{ id: window.rcSpVariantId, quantity: 1 }] };
      if (sectionsToBundle.length > 0) {
        spBody.sections = sectionsToBundle.join(',');
      }
      return fetch(rootPrefix + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(spBody)
      })
      .then(function (res) { return res.json(); })
      .then(function (spData) {
        return fetch(rootPrefix + 'cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            if (spData.sections) cart.sections = spData.sections;
            return cart;
          });
      })
      .catch(function () {
        /* SP failed — fetch cart without sections, drawer will still open */
        return fetch(rootPrefix + 'cart.js')
          .then(function (r) { return r.json(); });
      });
    })
    .then(function (cart) {
      /* Dispatch cart:change so Impact updates drawer content + cart count */
      document.documentElement.dispatchEvent(new CustomEvent('cart:change', {
        bubbles: true,
        detail: { baseEvent: 'variant:add', cart: cart }
      }));

      /* Dispatch variant:add so Impact opens the cart drawer (matches Impact's own ATC flow) */
      document.documentElement.dispatchEvent(new CustomEvent('variant:add', {
        bubbles: true
      }));

      /* Fallback: if drawer element doesn't exist, navigate to cart page */
      var drawerEl = document.getElementById('cart-drawer');
      if (!drawerEl) {
        window.location.href = rootPrefix + 'cart';
      }

      isSubmitting = false;
      btns.forEach(function (b) { b.disabled = false; b.classList.remove('rc-cta-btn--loading'); });
    })
    .catch(function (err) {
      console.error('ATC error:', err);
      isSubmitting = false;
      btns.forEach(function (b) { b.disabled = false; b.classList.remove('rc-cta-btn--loading'); });
      /* Fallback: redirect to checkout on any error */
      window.location.href = rootPrefix + 'checkout';
    });
  }

  document.querySelectorAll('.rc-atc-btn').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      addToCartAndOpenDrawer();
    });
  });

  /* ---- FAQ Accordion ---- */
  document.querySelectorAll('.rc-faq-item__question').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var item = btn.closest('.rc-faq-item');
      if (!item) return;
      var wasOpen = item.classList.contains('is-open');
      /* Close all */
      document.querySelectorAll('.rc-faq-item').forEach(function (fi) { fi.classList.remove('is-open'); });
      /* Toggle clicked */
      if (!wasOpen) item.classList.add('is-open');
    });
  });

  /* ---- Sticky Mobile CTA ---- */
  var stickyCta = document.querySelector('.rc-sticky-cta');
  var heroSection = document.querySelector('.rc-hero');

  if (stickyCta && heroSection) {
    var stickyLast = -1;
    function updateSticky() {
      var heroBottom = heroSection.getBoundingClientRect().bottom;
      var show = heroBottom < 0;
      var val = show ? 1 : 0;
      if (val !== stickyLast) {
        stickyCta.classList.toggle('is-visible', show);
        stickyLast = val;
      }
      requestAnimationFrame(updateSticky);
    }
    requestAnimationFrame(updateSticky);
  }

  /* ---- Announcement Bar Close ---- */
  var announcementClose = document.querySelector('.rc-announcement__close');
  if (announcementClose) {
    announcementClose.addEventListener('click', function () {
      var bar = announcementClose.closest('.rc-announcement');
      if (bar) bar.classList.add('is-hidden');
    });
  }

})();
